import React from 'react'
import { useDispatch } from 'react-redux'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import Auth from '../../commons/Auth/Auth'

const RecoveryPasswordAuthContainer = () => {
  const dispatch = useDispatch()
  const handleSubmit = (data) =>
    dispatch(reducks.resources.users.actions.resetPassword(data))

  const handleResent = () =>
    dispatch(reducks.resources.users.actions.resentResetPassword())

  return (
    <Auth
      handleSubmit={handleSubmit}
      handleResent={handleResent}
      back={routes.resetPasswordSentPassword.path}
    />
  )
}

export default RecoveryPasswordAuthContainer
